var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.066,5.136c-.829.368-1.709.609-2.609.715.949-.567,1.66-1.459,2.001-2.511-.891.529-1.867.901-2.883,1.101-1.717-1.831-4.593-1.924-6.424-.207-1.185,1.11-1.687,2.768-1.317,4.35-3.651-.184-7.052-1.909-9.358-4.746-1.206,2.075-.591,4.73,1.405,6.063-.721-.023-1.426-.217-2.057-.567v.056c0,2.162,1.523,4.025,3.642,4.453-.39.106-.793.16-1.197.159-.286,0-.572-.027-.853-.081.595,1.849,2.299,3.115,4.24,3.153-1.608,1.262-3.594,1.947-5.638,1.944-.362,0-.723-.02-1.082-.062,2.076,1.332,4.492,2.039,6.959,2.038,7.086.05,12.872-5.654,12.922-12.74,0-.06,0-.119,0-.179,0-.197-.005-.393-.014-.588.889-.642,1.657-1.437,2.267-2.349v-.003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.3128a82b307e5423b3059519a3d43fdb.svg";
export { ForwardRef as ReactComponent };